<template>
  <div class="schedule_index">
    <page-header :title="$tc('schedule.name', 2)"></page-header>
    <page-content>
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <ntm-block :title="$tc('defaults.name', 2)" :collapsable="true" :init-collapse="false">
            <form @submit.prevent="onSaveDefaults()">
              <formly-form :form="defaultsForm" :model="defaultsModel" :fields="defaultsFields"></formly-form>
              <button class="btn btn-success push-15">{{ $t('save') }}</button>
            </form>
          </ntm-block>
          <ntm-block>
            <template slot="options">
              <div class="flex flex-column">
              <multiselect :allowEmpty="false" style="min-width: 150px;" class="d-none d-inline-block" track-by="uuid"
                           v-model="currentSeason" :options="seasonOptions" @search-change="getOptions"
                           :customLabel="customLabel"></multiselect>
              <!--<input type="text" class="form-control" :placeholder="$t('search')"  v-model="search">-->
              <button @click="createPage()" type="button" class="btn btn-sm btn-success">{{$t('action.addNew')}}</button>

              </div>
            </template>
          </ntm-block>
          <div class="items-wrapper position-relative">
            <le-loading v-if="loading"></le-loading>
              <draggable handle=".drag-handle"
                         @change="changeOrder"
                         v-bind="dragOptions"
                         v-model="model"
                         @start="drag = true"
                         @end="drag = false">
                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                  <div class="block block-rounded mb-3" v-for="item in model" :key="item.uuid">
                    <div class="block-header" :class="{'bg-bisque': !item.showOnLandingPage}">
                      <h3 class="block-title" style="text-transform: unset"><i class="fa fa-bars drag-handle mr-3"></i> {{item.name}}</h3>
                      <div class="block-options">
                        <router-link :to="{ name: 'schedules.show', params: {uuid: item.uuid }}" :data-testid="'schedule-view-' + item.uuid" class="btn btn-sm btn-primary" v-tooltip="$t('tooltip.viewSchedule')">
                          <i class="fa fa-fw fa-eye"></i>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
          </div>
        </div>
      </div>

      <ntm-modal size="lg" :title="$tc('schedule.create')" ref="newSchedule">
        <template slot="content">
          <ntm-block :collapsable="false">
            <formly-form :form="createScheduleForm" :model="createScheduleModel" :fields="createScheduleFields"></formly-form>
          </ntm-block>
        </template>
        <template slot="footer">
          <button class="btn btn-success push-15" @click="onAddSchedule()">{{$t('save')}}</button>
        </template>
      </ntm-modal>
      <!-- END Full Table -->
    </page-content>
  </div>
</template>
<script>
import ScheduleService from '@/services/schedule.service'
import SettingsService from '@/services/settings.service'
import fields from './formDefinitions/createScheduleFormDefinition'
import settingsFormDefinition from '../settings/formDefinition'
import seasonIndexMixin from '@/mixins/season.index.mixin'
import draggable from 'vuedraggable'
import Multiselect from 'vue-multiselect'
import LeLoading from '@/components/ntm/LeLoading.vue'
export default {
  mixins: [seasonIndexMixin],
  components: {
    LeLoading,
    Multiselect,
    draggable
  },
  data () {
    return {
      drag: false,
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      },
      createScheduleForm: {},
      createScheduleModel: {},
      isInitialLoad: true,
      defaultsModel: {},
      defaultsForm: {},
      defaultsLoading: true
    }
  },
  mounted () {
    this.getOptions()
    SettingsService.index().then((response) => {
      this.defaultsModel = response.data
      this.$nextTick(() => {
        this.defaultsLoading = false
      })
    })
  },
  computed: {
    config () {
      return this.$store.state.config
    },
    isAiNewsLocked () {
      return this.$store.getters.disabledFeatures.includes('ai-news')
    },
    seasonOptions () {
      return this.$store.state.seasonOptions
    },
    currentSeason: {
      get: function () {
        return this.$store.state.currentSeason
      },
      // setter
      set: function (newValue) {
        this.$store.commit('setCurrentSeason', newValue)
      }
    },
    defaultsFields () {
      const dynamicFields = [...settingsFormDefinition.defaultsFields]

      return dynamicFields.map(field => {
        if (field.key === 'show_player_in_game_time_on_website' || field.key === 'show_player_plus_minus_on_website') {
          return {
            ...field,
            templateOptions: {
              ...field.templateOptions,
              disabled: !this.defaultsModel.has_substitutions
            }
          }
        }
        return field
      })
    },
    extendScheduleOptions () {
      return this.model?.filter(s => s.league.uuid !== this.createScheduleModel?.league?.uuid)
    },
    newLeagueModel () {
      return {
        extendsSchedules: [],
        league: null,
        suffix: null,
        periodTime: this.$store.state.settings.periodTime,
        number_of_regular_periods: this.$store.state.settings.numberOfRegularPeriods,
        overtimePeriodTime: this.$store.state.settings.overtimePeriodTime,
        minTeamPlayers: this.$store.state.config.isScout ? 0 : this.$store.state.config.min_team_players,
        maxTeamPlayers: this.$store.state.config.isScout ? null : this.$store.state.config.max_team_players,
        hideLeagueRankings: this.$store.state.config.isScout,
        gameDurationInMinutes: this.$store.state.config.gameDurationInMinutes,
        isTournament: false,
        showOnLandingPage: true,
        has_substitutions: this.$store.state.settings.has_substitutions,
        show_player_in_game_time_on_website: this.$store.state.settings.showPlayerInGameTimeOnWebsite,
        show_player_plus_minus_on_website: this.$store.state.settings.showPlayerPlusMinusOnWebsite,
        aiLeaguePreviousWeekSummaryNews: this.$store.state.settings.aiLeaguePreviousWeekSummaryNews ?? 'OFF',
        hasAIGamesNews: this.isAiNewsLocked ? false : this.$store.state.settings.hasAIGamesNews,
        aiGamesNewsHighlight: this.$store.state.settings.aiGamesNewsHighlight ?? 'NONE_GAMES',
        aiPlayerRecordsNews: true,
        is_exhibition: false
      }
    },
    createScheduleFields () {
      const dynamicFields = [...fields]

      if (this.config.ai) {
        if (!this.isAiNewsLocked && !dynamicFields.find(f => f.key === 'hasAIGamesNews')) {
          dynamicFields.push({
            key: 'hasAIGamesNews',
            type: 'boolean',
            templateOptions: {
              label: 'hasAIGamesNews'
            }
          })
        }

        if (!this.isAiNewsLocked && !dynamicFields.find(f => f.key === 'aiGamesNewsHighlight')) {
          dynamicFields.push({
            key: 'aiGamesNewsHighlight',
            type: 'ntm-select',
            isString: true,
            options: [
              'ALL_GAMES',
              'CLOSE_AND_IMPORTANT_GAMES',
              'NONE_GAMES'
            ],
            templateOptions: {
              label: 'aiGamesNewsHighlight',
              translated: true
            }
          })
        }

        if (!this.isAiNewsLocked && !dynamicFields.find(f => f.key === 'aiLeaguePreviousWeekSummaryNews')) {
          dynamicFields.push({
            key: 'aiLeaguePreviousWeekSummaryNews',
            type: 'ntm-select',
            isString: true,
            options: ['OFF', 'EVERY_MONDAY', 'EVERY_TUESDAY', 'EVERY_WEDNESDAY', 'EVERY_THURSDAY', 'EVERY_FRIDAY', 'EVERY_SATURDAY', 'EVERY_SUNDAY'],
            templateOptions: { translated: true, label: 'aiLeaguePreviousWeekSummaryNews' }
          })
        }

        // if (!dynamicFields.find(f => f.key === 'aiPlayerRecordsNews')) {
        //   dynamicFields.push({
        //     key: 'aiPlayerRecordsNews',
        //     type: 'boolean',
        //     templateOptions: { label: 'aiPlayerRecordsNews' }
        //   })
        // }
      }

      const extendsSchedulesField = dynamicFields.find(f => f.key === 'extendsSchedules')
      if (extendsSchedulesField) {
        extendsSchedulesField.options = this.extendScheduleOptions
      }

      return dynamicFields.map(field => {
        if (field.key === 'show_player_in_game_time_on_website' || field.key === 'show_player_plus_minus_on_website') {
          return {
            ...field,
            templateOptions: {
              ...field.templateOptions,
              disabled: !this.createScheduleModel.has_substitutions
            }
          }
        }
        if (['aiLeaguePreviousWeekSummaryNews', 'aiPlayerRecordsNews'].includes(field.key)) {
          return field
        }
        return field
      })
    }
  },
  watch: {
    'defaultsModel.has_substitutions' (val) {
      if (this.defaultsLoading) return

      if (val) {
        this.defaultsModel.show_player_in_game_time_on_website = true
        this.defaultsModel.show_player_plus_minus_on_website = true
      } else {
        this.defaultsModel.show_player_in_game_time_on_website = false
        this.defaultsModel.show_player_plus_minus_on_website = false
      }
    },
    'createScheduleModel.league' (league) {
      if (league && league.is_exhibition !== undefined) {
        this.createScheduleModel.is_exhibition = league.is_exhibition
      }
    },
    'createScheduleModel.has_substitutions' (val) {
      if (this.isInitialLoad) return

      if (val) {
        this.createScheduleModel.show_player_in_game_time_on_website = true
        this.createScheduleModel.show_player_plus_minus_on_website = true
      } else {
        this.createScheduleModel.show_player_in_game_time_on_website = false
        this.createScheduleModel.show_player_plus_minus_on_website = false
      }
    },
    extendScheduleOptions: {
      handler: function (newValue, oldValue) {
        this.updateExtendsScheduleOptions()
      }
    }
  },
  methods: {
    onSaveDefaults () {
      SettingsService.storeScheduleDefault(this.defaultsModel).then(async () => {
        await this.$store.dispatch('getClient')
        this.defaultsForm.$errors = {}
        this.$store.commit('loaded')
      }).catch((err) => {
        this.defaultsForm.$errors = err.response.data.errors
      })
    },
    customLabel (o) {
      return `${o.name ? o.name : ''}`
    },
    getOptions (q = '') {
      this.$store.dispatch('getSeasonOptions', q)
    },
    changeOrder (data) {
      ScheduleService.changeOrder(this.model)
    },
    fetchData () {
      ScheduleService.index('', this.$store.state.currentSeason.uuid).then((response) => {
        this.setData(response.data)
      })
    },
    setData (data) {
      this.model = data
      this.createScheduleModel = this.newLeagueModel
      this.loading = false
      this.$nextTick(() => {
        this.isInitialLoad = false
      })
    },
    updateExtendsScheduleOptions () {
      if (this.createScheduleModel.extendsSchedules) {
        this.createScheduleModel.extendsSchedules = this.createScheduleModel.extendsSchedules.filter(s => s.league.uuid !== this.createScheduleModel?.league?.uuid)
      }
    },
    createPage () {
      this.$refs.newSchedule.open()
    },
    onAddSchedule () {
      this.createScheduleModel.season = this.currentSeason.uuid
      ScheduleService.store(this.createScheduleModel).then((res) => {
        this.$refs.newSchedule.close()
        this.createScheduleModel = this.newLeagueModel
        this.$router.push({ name: 'schedules.show', params: { uuid: res.data.uuid } })
      }).catch((err) => {
        this.createScheduleForm.$errors = err.response.data.errors
      }).finally(() => {
        this.$store.commit('loaded')
      })
    }
  }
}
</script>
